// 기본알럿
export function alert(message, buttonTitle, header, callback, mode, cssClass) {
    var alertBody = {
        mode:mode,
        message: message,
        cssClass:cssClass,
        buttons: [
            {
                text: buttonTitle,
                handler: () => {
                    if (typeof callback == 'function') {
                        callback();
                    }
                },
            },]
    };
    if (header) {
        alertBody.header = header;
    }
    document.querySelector('ion-alert-controller').create(alertBody).then(alert => {
        alert.present();
    });
}

// 취소 및 확인버튼
export function alertConfirm(ref, message, confirmLabel, cancelLabel, confirmCallback, cancelCallback) {
    document.querySelector('ion-alert-controller').create({
        message: message,
        buttons: [
            {
                text: cancelLabel,
                role: 'cancel',
                cssClass: 'secondary',
                handler: () => {
                    // console.log('Confirm Cancel');
                    if (typeof cancelCallback == 'function') {
                        cancelCallback(ref);
                    }
                },
            },
            {
                text: confirmLabel,
                handler: () => {
                    confirmCallback(ref);
                },
            },
        ]
    }).then(alert => {
        alert.present();
    });
}

// 확인 버튼을 누르면 페지 이동
export function alertNavigation(message, buttonTitle, ref, link) {
    document.querySelector('ion-alert-controller').create({
        message: message,
        buttons: [
            {
                text: buttonTitle,
                handler: () => {
                    ref.$router.push(link);
                },
            },
        ]
    }).then(alert => {
        alert.present();
    });
}

// 확인 버튼을 누르면 외부 페지 이동
export function alertLink(message, buttonTitle, ref, link) {
    document.querySelector('ion-alert-controller').create({
        message: message,
        mode: "ios",
        buttons: [
            {
                text: buttonTitle,
                handler: () => {
                    location.href = link;
                },
            },
        ]
    }).then(alert => {
        alert.present();
    });
}

// 텍스트 입력
// alert.alertPrompt("플레이리스트 Input your name, please.", "플레이리스트명", function(data) {
//     console.log(data);
// });
export function alertPrompt(ref, message, placeholder, callback) {
    document.querySelector('ion-alert-controller').create({
        message: message,
        inputs: [
            {
                id:"maxlength14",
                placeholder: placeholder,
            }
        ],
        buttons: [
            {
                text: '취소',
                role: 'cancel',
                cssClass: 'secondary',
                handler: () => {
                    // console.log('Confirm Cancel');
                },
            },
            {
                text: '확인',
                handler: (data) => {
                    callback(ref, data);
                },
            },
        ]
    }).then(alert => {
        alert.present().then(result =>{
                document.getElementById('maxlength14').setAttribute('maxlength','14');
        });
    });
}

// login alert
export function alertLogin(ref) {
    document.querySelector('ion-alert-controller').create({
        message: "로그인 후에 이용할 수 있는 서비스입니다.\n로그인 하시겠습니까?",
        buttons: [
            {
                text: '취소',
                role: 'cancel',
                cssClass: 'secondary',
                handler: () => {
                    // console.log('Confirm Cancel');
                },
            },
            {
                text: '확인',
                handler: () => {
                    ref.$router.push('/login');
                },
            },
        ]
    }).then(alert => {
        alert.present();
    });
}
